"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function bch(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M15.8664 7.91361C15.2844 6.43461 13.8249 6.30111 12.1254 6.63111L11.5202 4.52136L10.2362 4.88961L10.8257 6.94461C10.4882 7.04061 10.1447 7.14711 9.80341 7.25211L9.21091 5.18361L7.92766 5.55111L8.53141 7.66086C8.25541 7.74636 7.98391 7.83036 7.71766 7.90686L7.71541 7.89936L5.94391 8.40711L6.33766 9.77961C6.33766 9.77961 7.28116 9.48861 7.26991 9.51111C7.79041 9.36186 8.04616 9.61536 8.16991 9.86211L8.85991 12.2651C8.89516 12.2554 8.94241 12.2434 8.99791 12.2351L8.86216 12.2741L9.82741 15.6416C9.85141 15.8119 9.83041 16.1006 9.46741 16.2056C9.48766 16.2154 8.53291 16.4726 8.53291 16.4726L8.71816 18.0799L10.3892 17.5999C10.7004 17.5121 11.0079 17.4296 11.3087 17.3449L11.9214 19.4786L13.2039 19.1111L12.5987 16.9999C12.9427 16.9086 13.2857 16.8136 13.6277 16.7149L14.2292 18.8171L15.5139 18.4489L14.9034 16.3189C17.0267 15.5756 18.3819 14.5984 17.9882 12.5164C17.6717 10.8409 16.6952 10.3324 15.3849 10.3894C16.0209 9.79686 16.2947 8.99586 15.8664 7.91436V7.91361ZM15.3789 12.9911C15.8364 14.5864 13.0539 15.1879 12.1839 15.4384L11.3732 12.6109C12.2432 12.3611 14.9012 11.3284 15.3782 12.9919L15.3789 12.9911ZM13.6374 9.17361C14.0529 10.6249 11.7272 11.1086 11.0019 11.3164L10.2669 8.75211C10.9914 8.54436 13.2032 7.66086 13.6374 9.17436V9.17361Z", fill: color }));
}
exports["default"] = bch;
//# sourceMappingURL=bch.js.map